import React, {Component} from 'react';
import {connect} from 'react-redux';


import '../../styles/classroom/ClassroomTopNotify.css';


class ClassroomTopNotify extends Component{
	componentWillUnmount(){
		this.notifyTimer && clearTimeout(this.notifyTimer);
	}

	componentDidUpdate(){
		const {topNotify} = this.props
		this.notifyTimer && clearTimeout(this.notifyTimer);
		if(topNotify.show){
			this.notifyTimer = setTimeout(() => {
				this.props.dispatch({
					type: 'CLASSROOM_HIDE_TOPNOTIFY'
				})
			}, 4000);
		}
	}

	render(){
		const {topNotify} = this.props

		if(!topNotify.show){
			return null;
		}

		return (<div className="classroom-top-notify">
				{topNotify.text}
			</div>);
	}
}


export default connect((state) => ({
	topNotify: state.classroom.topNotify
}))(ClassroomTopNotify)




// WEBPACK FOOTER //
// ./src/components/classroom/ClassroomTopNotify.js